import { useMemo } from 'react';
import { useAsync } from 'react-use';

import { configApiRef, useApi } from '@backstage/core-plugin-api';

import { useInteractiveBrowserCredential } from './useInteractiveBrowserCredential';

export const useGetAzureToken = () => {
  const config = useApi(configApiRef);
  const apiUrl = config.getString('kaap.apiUrl');
  const credentials = useInteractiveBrowserCredential();
  const additionalScopes = useMemo(() => [`${apiUrl}/.default`], [apiUrl]);

  const getToken = useAsync(async (): Promise<{ token: string }> => {
    let accessToken;

    try {
      accessToken = await credentials.getToken(additionalScopes);
      return { token: accessToken.token };
    } catch (error: any) {
      if (error?.name === 'AuthenticationRequiredError') {
        await credentials.authenticate(additionalScopes);
        accessToken = await credentials.getToken(additionalScopes);
      } else {
        throw error;
      }
    }

    if (!accessToken?.token) {
      throw new Error('Failed to acquire Azure access token');
    }

    return { token: accessToken.token };
  }, [additionalScopes, credentials]);

  return getToken.value;
};
